import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=9ef4e7be&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"
import style0 from "./aboutUs.css?vue&type=style&index=0&id=9ef4e7be&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef4e7be",
  null
  
)

export default component.exports